import React, { useCallback, useMemo, useState } from 'react';
import {
  IonAvatar,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonSearchbar,
  IonText,
  useIonViewDidEnter
} from '@ionic/react';
import { addOutline, checkmark, ribbonOutline } from 'ionicons/icons';
import PayActions, { PaySelectors } from 'redux/PayRedux';
import { useSelector, useDispatch } from 'react-redux';
import { AppSelectors } from 'redux/AppRedux';
import { useHistory } from 'react-router';

function LoyaltyExplorePgs() {
  const dispatch = useDispatch();

  const history = useHistory();

  const loyaltyPrograms = useSelector(PaySelectors.selectLoyaltyPrograms);
  const loyaltyPoints = useSelector(PaySelectors.selectLoyaltyPoints);
  const venues = useSelector(AppSelectors.selectVenues);

  const [keyword, setKeyword] = useState('');

  useIonViewDidEnter(() => {
    dispatch(PayActions.loadLoyaltyPoints());
  });

  const handleChangeValue = (e) => {
    setKeyword(e.target.value);
  };


  const filterLoyaltyPrograms = useMemo(() => {
    if (!loyaltyPrograms.length) {
      return [];
    }

    return loyaltyPrograms.filter(item => item?.name?.toLowerCase().indexOf(keyword?.toLowerCase()) !== -1)
  }, [loyaltyPrograms, keyword]);

  const availablePoints = useCallback((id) => {
    const filterLoyaltyPoints = loyaltyPoints.filter(item => item.programId === id);

    const points = filterLoyaltyPoints.reduce(
      (sumPoints, item) => {
        return sumPoints + item.availablePoints;
      }, 0);

    return points.toFixed(0);
  }, [loyaltyPoints]);

  const isOptInProgram = useCallback((programId) => {
    return loyaltyPoints.some(point => point.programId === programId);
  }, [loyaltyPoints]);

  const getDetailVenue = useCallback((venueIds) => {
    if (!venueIds || !venueIds?.length) {
      return null;
    }

    const filterVenue = venues.filter(item => venueIds.some(id => id === item.id));

    if (filterVenue?.length > 0) {
      return filterVenue[0];
    }

    return null;
  }, [venues])

  const onItemAction = (programId) => {
    history.push((`/loyalty/${programId}/detail`), { hideBottomMenu: true });
  }

  return (
    <>
      {
        filterLoyaltyPrograms.length > 0 ? (
          <IonList className="ion-padding">
            <IonItem lines="none" className="mb-3x">
              <IonSearchbar
                className="searchbar-input"
                onIonChange={handleChangeValue}
                value={keyword}
              />
            </IonItem>

            {filterLoyaltyPrograms.map((item) => (
              <IonItem
                className="mb-2x"
                key={item.id}
                onClick={() => {
                  onItemAction(item.id);
                }}
              >
                <div className="loyalty-menu-logo-wrapper">
                  {
                    getDetailVenue(item.venueIds) &&
                    <IonAvatar slot="start" className="loyalty-menu-logo-size">
                      <IonImg src={getDetailVenue(item.venueIds)?.logo} />
                    </IonAvatar>
                  }
                </div>

                <div className="d-flex-content ml-2">
                  <IonLabel className="ion-text-wrap">
                    <h2>{item?.name}</h2>
                  </IonLabel>


                  <div className="loyalty-coin-wrap mb-2x">
                    <IonLabel className="ion-text-wrap mr-1">
                      <IonText color="tertiary"><h6><b>{availablePoints(item.id)}</b></h6></IonText>
                    </IonLabel>
                    <IonImg src="/assets/vemos-coin.png" className="coin-img-icon" />
                  </div>
                </div>

                <div className="loyalty-arrow-icon-wrapper">
                  <IonIcon
                    className="loyalty-icon"
                    icon={isOptInProgram(item.id) ? checkmark : addOutline}
                    color="secondary"
                  />
                </div>

              </IonItem>
            ))}

          </IonList>
        ) : (
          <IonList className="ion-padding">
            <IonItem lines="none" className="mt-3x mb-3x">
              <div className="d-flex-content">
                <div className="loyal-search-noresult-icon-wrapper">
                  <IonIcon
                    className="loyalty-noresult-icon"
                    icon={ribbonOutline}
                    color="dark"
                  />
                </div>
              </div>
            </IonItem>

            <IonItem lines="none" className="mb-2x">
              <IonLabel className="text-center ion-text-wrap">
                <h1>You haven't singed up for any loyalty programs yet.</h1>
              </IonLabel>
            </IonItem>

            <IonItem lines="none" className="mb-2x">
              <IonLabel className="text-center ion-text-wrap">
                <h2>Manage all your loyalty programs in one place!</h2>
              </IonLabel>
            </IonItem>

            <IonItem lines="none" className="mb-2x">
              <IonLabel className="text-center ion-text-wrap">
                <p>Once you sign up for venue loyalty programs, they'll all appear here for you to easily track and manage your status.</p>
              </IonLabel>
            </IonItem>
          </IonList>
        )
      }

    </>
  );
}

export default LoyaltyExplorePgs;
